import { useParams } from "react-router";
import { useGetInquiryDetails, useMarkInquiryResolved } from "../../queries/helpDesk";
import Chip from "../../components/Chip";
import { ActionButton } from "../../components/Forms/ActionButton";
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useNavigate } from 'react-router-dom';

const InquiryDetails = () => {

    const navigate = useNavigate();
    const { id } = useParams();
    const { data, isPending } = useGetInquiryDetails(id);
    const { mutateAsync, isPending: isMarkingAsResolved } = useMarkInquiryResolved();

    const handleMarkAsResolved = async () => {
        await mutateAsync(id, {
            onSuccess: (res) => {
                if (res.error) {
                    toast.error('Something went wrong!');
                    return;
                }
                toast.success('Inquiry marked as resolved!');
                setTimeout(() => {
                    navigate('/help-desk/inquiries');
                }, 2000);
            },
            onError: () => {
                toast.error('Something went wrong!');
            }
        });
    }

    if (isPending) {
        return <div>Loading...</div>;
    }

    return (
        <section className="bg-white rounded-md shadow p-4 mb-4 text-base">
            <div className="mb-2 font-semibold text-xl">Inquiry Details</div>
            <div className="flex flex-col gap-4">
                <div className="flex gap-1">
                    <label className="font-semibold text-primary">Name:</label>
                    <div className="flex items-center gap-1">
                        <p>{`${data.firstName} ${data.lastName}` || '-'}</p>
                    </div>
                </div>
                <div className="flex gap-1">
                    <label className="font-semibold text-primary">Email:</label>
                    <p>{data.email || '-'}</p>
                </div>
                <div className="flex gap-1">
                    <label className="font-semibold text-primary">Contact No:</label>
                    <p>{data.mobile || '-'}</p>
                </div>
                <div className="flex gap-1">
                    <label className="font-semibold text-primary">Subject:</label>
                    <p>{data.subject || '-'}</p>
                </div>
                <div className="flex items-center gap-1">
                    <label className="font-semibold text-primary">Status:</label>
                    <Chip
                        value={data.status}
                        color={data.status === 'pending' ? 'inactive' : 'green'}
                        small={true}
                    />
                </div>
                <div className="flex gap-1">
                    <label className="font-semibold text-primary">Created At:</label>
                    <p>{new Date(data.createdAt).toLocaleDateString()}</p>
                </div>
                <div className="flex gap-1">
                    <label className="font-semibold text-primary">Created By:</label>
                    {
                        data.createdBy.userId?.profilepic && (
                            <img src={data.createdBy.userId?.profilepic} alt="-" className="size-4 rounded-full" />
                        )
                    }
                    <p>{data.createdBy?.userId?.name?.firstName + " " + data.createdBy?.userId?.name?.lastName || '-'}</p>
                </div>
                <div className="flex flex-col gap-1">
                    <label className="font-semibold text-primary">Description:</label>
                    <p className="text-gray-700">{data.description || '-'}</p>
                </div>
            </div>
            <div className="mt-5 flex justify-end items-center">
                <ActionButton
                    text={'Mark as Resolved'}
                    variant={'submit'}
                    disabled={isMarkingAsResolved}
                    handleSubmit={handleMarkAsResolved}
                />
            </div>
            <ToastContainer
                position="top-right"
                autoClose={2000}
            />
        </section>
    );
}

export default InquiryDetails;